import { Address } from 'types';

/** Formats an {@link Address} to a single line string. */
export const formatAddress = (address: Address | undefined): string => {
  if (!address) {
    return '';
  }

  const { address1, address2, city, state, zip } = address;

  return `${address1}${address2 ? `, ${address2}` : ''}, ${city}, ${state} ${zip}`;
};
